import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";
import classnames from "classnames";

interface Props {
	className?: string;
}
const TasksTableHeadings = ({ className }: Props) => {
	const { t } = useTranslation();

	return (
		<div
			className={classnames(
				"list-group-heading tasks__heading",
				className
			)}>
			<CardColumn className="task-card--heading__title" width="xl">
				{t("main.tasks.headings.title")}
			</CardColumn>
			<CardColumn className="task-card--heading__status" width="xs">
				{t("main.tasks.headings.status")}
			</CardColumn>
			<CardColumn className="task-card--heading__started" width="md">
				{t("main.tasks.headings.started")}
			</CardColumn>
			<CardColumn className="task-card--heading__due-date" width="xs">
				{t("main.tasks.headings.dueDate")}
			</CardColumn>
			<CardColumn className="task-card--heading__priority" width="xs">
				{t("main.tasks.headings.priority")}
			</CardColumn>
			<CardColumn className="task-card--heading__assignee" width="md">
				{t("main.tasks.headings.assignee")}
			</CardColumn>
			<CardColumn className="activity-instances-card__menu" />
		</div>
	);
};

export default TasksTableHeadings;
